import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {
  addUserToDialogue,
  dialogueAsyncActions,
  getDialogue,
  getTranslations
} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import ChatroomImg from 'assets/image/menu-auth/jun_chatroom.png';
import {Link, useParams} from 'react-router-dom';

import './styles.scss';

export const ChatroomChat: React.FunctionComponent = () => {
  const {
    status: {loading},
    dialogue: {
      dialogue, participant
    },
    auth: {
      userProfile
    }
  } = useSelector((state: IStore) => state);
  const dispatch = useDispatch();
  const shouldLoad = useRef(true);
  const {dialogueId} = useParams();

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (dialogueId && userProfile) {
      if (shouldLoad.current) {
        shouldLoad.current = false;
        dispatch(dialogueAsyncActions[addUserToDialogue](userProfile.id, Number(dialogueId)));
        dispatch(dialogueAsyncActions[getDialogue](Number(dialogueId)));
      }
    }
  }, [dialogueId, userProfile]);

  useGetTranslations({
    translationKey: TranslationKeys.Chat
  });

  function renderBreadcrumbs() {
    return <div className="breadcrumbs">
      <Link className="breadcrumbs__previous" to="/chatroom">
        <FormattedMessage
          id={'gritx.chatroom.breadcrumb.previous'}
          defaultMessage="Chatroom"
        />
      </Link> {dialogue && <span className="chatroom-chat__title-dialogue-name"> - {dialogue.name}</span>}
    </div>;
  }

  return <div className="chatroom-chat">
    {
      !loading.includes(getTranslations) && dialogue && participant && <>
        <h1 className="chatroom-chat__title">
          <img src={ChatroomImg} alt="" className="chatroom-chat__icon"/>
          {renderBreadcrumbs()}
        </h1>
        <BotChat mode={BotType.Dialogue} dialogueId={dialogue.id} title={dialogue.name} />
      </>
    }
  </div>;
};
